import { type MotifComponent, type MotifComponentProps, m } from '../../motif';

export const snapToggleSliderPrimaryVars: MotifComponentProps<MotifComponent.TOGGLE_SLIDER> = {
  '--toggle-slider-bg-color': m('--neutral-v400'),
  '--toggle-slider-active-color': m('--neutral-v700'),
  '--toggle-slider-switch-color': m('--neutral-v0'),
} as const;
